import * as React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Box, Text, Flex } from '@chakra-ui/react';
import { getFilter, checkMatch, isObjEmpty } from '../../utitlities/productsFilter';
import LinkWrapper from '../LinkWrapper';
import queryString from 'query-string';

/* IMPORT APP CONTEXT */
import { AppContext } from '../../context';

const isBrowser = typeof window !== "undefined";

function ProductsList(props) {
  /* FILTER FROM ProductsListFilter SECTION */
  const { filter, productsToFilter, productsBaseRoute, location } = props;
  const appContext = React.useContext(AppContext);

  const [listMounted, setListMounted] = React.useState(false);
  const [newFilter, setNewFilter] = React.useState(null);

  React.useEffect(() => {
    // console.log('PRODUCT LIST MOUNTED');
    setListMounted(true);
    
    return () => {
      // console.log('PRODUCT LIST UNMOUNTED');
      setListMounted(false);

    };
    
  }, []);

  let productsRendered = 0;

  /* CHECK IF FILTER CHANGED */
  const [oldFilter, setOldFilter] = React.useState('empty');

  /* CHECK IF HREF CHANGED */
  const [prevHref, setPrevRef] = React.useState(location.href);

  React.useEffect(() => {
    if (location.href !== prevHref) {
      // console.log('productsList location changed: ', location.href);
      setPrevRef(location.href);
      appContext.productsListTopRef.current?.scrollIntoView();

      productsRendered = 0;
      
    } else {
      // console.log('productsList location did not change: ');
    }

  }, [location]);

  /* LIST SHOWN CONTROL */
  const [showFullList, setShowFullList] = React.useState(true);

  React.useEffect(() => {
    /* GET FILTER INFO RIGHT FROM THE URL INSTEAD OF THE FILTER PROP, FILTER PROP IS JUST USED TO TRIGGER THIS USEEFFECT */
    const objArr = {};
    const qsObject = queryString.parse(location.search, { arrayFormat: 'comma' });

    Object.keys(qsObject).map((item, indx) => {
      
      if (typeof qsObject[item] === 'string') {
        objArr[item] = [qsObject[item]];
      } else {
        objArr[item] = qsObject[item];
      }
    });

    /* REMOVE THE PARAMS ADDED BY THE UTM LINKS */
     const { 
         utm_campaign, utm_medium, utm_source, 
         utm_id, utm_term, utm_content, _kx,
         ...productFilter 
      }:any  = objArr;
      

    /* UPDATE FILTER */
    if (location.href.includes('?') && !isObjEmpty(productFilter)) {
      /* GET FILTER INFO WITHOUT THE UTM PARAMS IF THERE ARE ANY - SHOW FILTERED PRODUCTS LIST */
      const filterToUse = getFilter(productFilter);
      if (oldFilter !== filterToUse.toString()) {
        setOldFilter(filterToUse.toString());
        setNewFilter(filterToUse);
        setShowFullList(false);

      }

    } else if ((location.href.includes('?') && isObjEmpty(productFilter)) ||
               (!location.href.includes('?')) ) {
      /* THERE ARE NO FILTERS JUST THE UTM PARAMS - SHOW FULL PRODUCTS LIST */
      if (oldFilter !== 'empty') {
        setOldFilter('empty');
        setShowFullList(true);
      }
    } 
  }, [filter]);

  return (
    <>
      <Box 
        w={{ base: '100%' }} 
        // h={showLoadMore ? listHeight : 'auto'} 
        h="auto"
        position="relative"
        // bgColor="red"
        overflow="hidden"
        id="products-list"
      >
        {/* PRODUCTS LIST */}
        {listMounted && productsToFilter.length > 0 && (
          <>
            {/* FILTERED LIST */}
            <Flex 
              w={{base:'100%'}} 
              flexWrap='wrap' 
              justifyContent={{base:'space-evenly'}}
              display={!showFullList ? 'flex' : 'none'}
              // bgColor="red"
            >
              {productsToFilter.map((product, indx) => {
                productsRendered += (checkMatch(product, newFilter) && product?.isPublic) ? 1 : 0;
                // console.log('rendered filter: ', productsRendered);

                return (
                  <React.Fragment key={indx}>
                    {checkMatch(product, newFilter) && product?.isPublic && (
                      <Product 
                        product={product} 
                        routeBase={productsBaseRoute}  
                        filter={filter}
                      />
                    )}
                  </React.Fragment>
                );
              })}

              {/* FIX TO FILL BLANK SPACE */}
              <Box w={{ base: '276px' }}></Box>
              <Box w={{ base: '276px' }}></Box>
            </Flex>
          
            {/* UNFILTERED LIST */}
            <Flex 
              w={{base:'100%'}} 
              flexWrap='wrap' 
              justifyContent={{base:'space-evenly'}}
              display={showFullList ? 'flex' : 'none'}
              // bgColor="blue"
            >
              {productsToFilter.map((product, indx) => {
                // productsRendered += product?.isPublic ? 1 : 0;
                // console.log('rendered no filter: ', productsRendered);

                return (
                  <React.Fragment key={indx}>
                    {product?.isPublic && (
                      <Product 
                        product={product} 
                        routeBase={productsBaseRoute}
                        filter={filter}
                      />
                    )}
                  </React.Fragment>
                );
              })}

              {/* FIX TO FILL BLANK SPACE */}
              <Box w={{ base: '276px' }}></Box>
              <Box w={{ base: '276px' }}></Box>
            </Flex>
          </>
        )}

        {/* NO RESULTS */}
        {listMounted && !showFullList && productsRendered === 0 && (<NoResults text={'There are no products matching the filter you selected.'} />)}
      </Box>
    </>
  );
}
let tryOnce = true
/* PRODUCT COMPONENT */
const Product = ({ product, routeBase, filter }) => {
  const [imageByState, setImageByState] = React.useState('');
  let allLineages = '';
  product.lineages.map(item => allLineages += `${item.name} | `);

  const handleImage = () => {
    let productImage;
    if(filter?.state) { // is there a filter?
      for (let i = filter?.state?.length; i > 0; i--) { // loop every filter in the array starting from the last item
        let lastProductByState = product.infoPerState.filter(item => {
          // Slugs uses hyphens instead of spaces, yet product filters (like state) use spaces
          let formattedSlug = item.state.slug.current.trim().toLowerCase().replace('-', ' ');
          return formattedSlug === filter?.state[i - 1];
        }) // filter item by the current filter
        if(lastProductByState.length !== 0) { // product find in the current filter then return the its image
          productImage = lastProductByState[0]?.productImage?.asset?.gatsbyImageData
          i = 0
        } else { // no product in the current filter then go to the next filter
          if(i === 1) { // no product exist for any filter then return default image
            productImage = product.collectionImage.asset.gatsbyImageData
          }
        }
      }
    } else { // if no filter then return default image
      productImage = product.collectionImage.asset.gatsbyImageData
    }

    return productImage
  }

  return (
    <LinkWrapper
      href={`${routeBase}${product.category.slug.current}${product.subcategory ? `/${product.subcategory.slug.current}` : ''}/${product.slug.current}`}
    >
      <Flex 
        w={{ base: '276px' }} 
        display='flex' 
        flexDirection={{ base: 'column' }} 
        mb={{ base: '30px' }}
        border="1px"
        borderColor="transparent"
      >
        {/* PRODUCT IMAGE */}
        <Flex
          w={{ base: '276px' }}
          h={{ base: '276px' }}
          bgColor={product.collectionImage ? 'transparent' : 'gray.200'}
          justifyContent='center'
          alignItems='center'
          // border="1px"
        >
          {product.collectionImage && (
            <GatsbyImage image={handleImage()} alt={'wana product image'} />
          )}
        </Flex>

        {/* PRODUCT DETAILS */}
        <Box 
          ml={{ base: '20px' }} 
          mt={{ base: '28px' }}
        >
          {/* SUBCATEGORY - CATEGORY */}
          <Text
            color={'primary'}
            fontSize={{ base: '12px' }}
            fontWeight='600'
            textTransform='uppercase'
            letterSpacing={{ base: '2px' }}
            lineHeight={{ base: '35px' }}
          >
            {`${product.subcategory ? product.subcategory.name : ''} ${
              product.category.name
            }`}
          </Text>

          {/* NAME */}
          <Text
            maxH={{ base: '18px' }}
            color={'primaryDarker'}
            fontSize={{ base: '18px' }}
            fontWeight='900'
            textTransform='uppercase'
            letterSpacing={{ base: '0' }}
            lineHeight={{ base: '18px' }}
            whiteSpace={{base:'nowrap'}}
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {product.name}
          </Text>

          {/* LINEAGES | CONTENT */}
          <Text
            color={'primaryDarker'}
            fontSize={{ base: '15px' }}
            fontWeight='bold'
            // textTransform='capitalize'
            letterSpacing={{ base: '0' }}
            lineHeight={{ base: '35px' }}
            mt={{ base: '0' }}
            mb={{ base: '0' }}
            whiteSpace={{base:'nowrap'}}
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {allLineages.substring(0, allLineages.length-2)}
          </Text>

          {/* PRICE */}
          {/* {price && (
            <Text
              color={'greenMantis'}
              fontSize={{ base: '18px' }}
              fontWeight='900'
              letterSpacing={{ base: '0' }}
              lineHeight={{ base: '35px' }}
            >
              {`$${price ? price.total : '15.00'} ${price ? price.currency : 'ea'}.`}
            </Text>
          )} */}
        </Box>
      </Flex>
    </LinkWrapper>
  );
};

/* NO RESULTS  COMPONENT */
const NoResults = ({ text }) => {
  return (
    <Box 
      w='100%' 
      h='auto' 
      pt={{base:'0', md:'8px'}} 
      borderTop={{base:'0', md:'1px'}}
      borderColor='primary'
      mt={{base:'0px', md:'0'}}
    >
      <Text
        textAlign={{base:'center', md:'left'}}
      >
        {text}
      </Text>
    </Box>
  );
};

export default ProductsList;
